import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useNavigate, useParams } from 'react-router-dom';

const LoggingIn = () => {
    const intl = useIntl();
    const navigate = useNavigate();
    const { practitionerId } = useParams();

    useEffect(() => {
        document.title = intl.formatMessage({ id: 'LP_DASHBOARD_TITLE', defaultMessage: 'Practitioner Dashboard' });
    }, [intl]);

    useEffect(() => {
        if (practitionerId) {
            localStorage.setItem('active_practitioner_id', practitionerId);
            navigate('/');
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [practitionerId]);

    return <></>;
};

export default LoggingIn;